import type { AllMenuItem } from 'app/modules/BettingMenu/types';

export const getFilteredMenuLayerItemByTimeFilter = <T extends AllMenuItem>(
  menuLayerItems: Array<T>,
  filteredMatchesByStartDate: Set<number>,
): Array<T> => {
  const filteredUnionsMenuLayerItem: Array<T> = [];

  menuLayerItems.map((menuLayerItem) => {
    const matchIds = new Set<number>();

    menuLayerItem.entity.matchIds.forEach((matchId) => {
      if (filteredMatchesByStartDate.has(matchId)) {
        matchIds.add(matchId);
      }
    });

    if (matchIds.size > 0) {
      filteredUnionsMenuLayerItem.push({
        ...menuLayerItem,
        entity: {
          ...menuLayerItem.entity,
          matchIds,
          matchesCount: matchIds.size,
        },
      });
    }
  });

  return filteredUnionsMenuLayerItem;
};
